/* RF Nation welcome pop-up — storefront renderer.
 * Installed into the store's theme as assets/rf-welcome.js and configured by
 * snippets/rf-welcome.liquid (window.RFWelcome). Managed from the RF Nation
 * dashboard; the same file draws the dashboard's previews, so what the owner
 * sees there is what customers see here.
 *
 * Screens: the sign-up pop-up, the code pop-up, and the unsubscribe page (a
 * store page carrying <div data-rf-unsubscribe>). Everything renders inside a
 * shadow root so the theme's CSS can't bend it, and every text goes in as
 * textContent — no HTML from the config ever reaches the page.
 */
(function () {
  "use strict";
  var C = window.RFWelcome;
  if (!C || window.__rfWelcomeLoaded) return;
  window.__rfWelcomeLoaded = true;

  var PREVIEW = C.mode === "preview";
  var B = C.brand || {};
  var R = C.rules || {};
  var KEY = "rfw:" + (C.store || "store");
  var params;
  try { params = new URLSearchParams(location.search); } catch (e) { params = { get: function () { return null; } }; }

  // ── storage that never throws (private mode, blocked cookies) ──
  function sget(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function sset(store, k, v) { try { window[store].setItem(k, v); } catch (e) {} }
  function sdel(store, k) { try { window[store].removeItem(k); } catch (e) {} }

  // ── test mode: ?rf_test=1 shows the pop-up to this browser only, from a clean slate ──
  var testParam = params.get("rf_test");
  if (testParam === "1") sset("sessionStorage", KEY + ":test", "1");
  if (testParam === "0") sdel("sessionStorage", KEY + ":test");
  var TEST = sget("sessionStorage", KEY + ":test") === "1";
  var SKEY = KEY + (TEST ? ":test-state" : ":state");
  if (testParam === "1") sdel("localStorage", SKEY);

  function loadState() { try { return JSON.parse(sget("localStorage", SKEY) || "{}") || {}; } catch (e) { return {}; } }
  function saveState(s) { sset("localStorage", SKEY, JSON.stringify(s)); }

  function visitId() {
    var v = sget("sessionStorage", KEY + ":vid");
    if (!v) {
      v = String(Date.now()) + Math.random().toString(36).slice(2, 8);
      sset("sessionStorage", KEY + ":vid", v);
      sset("sessionStorage", KEY + ":start", String(Date.now()));
    }
    return v;
  }
  function visitStart() { return Number(sget("sessionStorage", KEY + ":start")) || Date.now(); }

  // ── tiny DOM helper: text only, never innerHTML ──
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (!Object.prototype.hasOwnProperty.call(attrs, k) || attrs[k] == null || attrs[k] === false) continue;
      if (k === "class") el.className = attrs[k];
      else if (k === "text") el.textContent = attrs[k];
      else if (k.slice(0, 2) === "on") el.addEventListener(k.slice(2), attrs[k]);
      else el.setAttribute(k, attrs[k] === true ? "" : attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c) el.appendChild(typeof c === "string" ? document.createTextNode(c) : c); });
    return el;
  }
  function safeUrl(u, rel) {
    u = String(u || "");
    if (/^https:\/\/[^\s"'<>]+$/.test(u)) return u;
    if (rel && /^\/(?!\/)/.test(u)) return u;
    return "";
  }

  // ── look ──
  function fam(name, fallback) { return name ? "\"" + String(name).replace(/["\\]/g, "") + "\", " + fallback : fallback; }
  var themeFonts = C.themeFonts || {};
  var HF = fam(themeFonts.heading || B.heading_font, "Georgia, 'Times New Roman', serif");
  var BF = fam(themeFonts.body || B.body_font, "-apple-system, 'Segoe UI', Helvetica, Arial, sans-serif");
  var ACC = B.accent || "#111111", ON = B.button_text || "#ffffff", TXT = B.text || "#1f1f1f", PANEL = B.panel || "#f7f4ee";

  function css() {
    return [
      ":host{all:initial}",
      "*{box-sizing:border-box}",
      ".ov{position:fixed;inset:0;z-index:2147483000;background:rgba(20,18,16,.55);display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .25s ease}",
      ".ov.open{opacity:1}",
      ".dlg{position:relative;display:flex;width:100%;max-width:880px;max-height:calc(100vh - 32px);overflow:auto;background:" + PANEL + ";color:" + TXT + ";box-shadow:0 24px 70px rgba(0,0,0,.35);transform:translateY(12px) scale(.98);transition:transform .3s cubic-bezier(.2,.8,.2,1)}",
      ".ov.open .dlg{transform:none}",
      ".dlg.flip{flex-direction:row-reverse}",
      ".img{flex:0 0 50%;min-height:440px;background-size:cover;background-position:center}",
      ".body{flex:1;padding:48px 44px 36px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;font-family:" + BF + "}",
      ".body > div{width:100%;display:flex;flex-direction:column;align-items:center}",
      ".x{position:absolute;top:12px;right:12px;width:40px;height:40px;border:0;background:transparent;color:" + TXT + ";font-size:28px;line-height:1;cursor:pointer;border-radius:50%}",
      ".x:hover{background:rgba(0,0,0,.06)}",
      ".logo{max-width:200px;max-height:64px;margin:0 auto 22px;display:block}",
      ".eb{font-family:" + HF + ";text-transform:uppercase;letter-spacing:.28em;font-size:13px;color:" + ACC + ";margin:0 0 14px}",
      ".t{font-family:" + HF + ";font-size:40px;line-height:1.08;font-weight:400;margin:0 0 16px;color:" + TXT + "}",
      ".p{font-size:17px;line-height:1.55;margin:0 0 24px;max-width:420px}",
      "form{width:100%;max-width:400px;margin:0}",
      ".fld{width:100%;height:52px;padding:0 18px;border:1px solid rgba(0,0,0,.22);background:#fff;color:#1f1f1f;font:16px/1 " + BF + ";outline:none;border-radius:0}",
      ".fld:focus{border-color:" + ACC + ";box-shadow:0 0 0 2px " + ACC + "33}",
      ".btn{width:100%;height:54px;margin-top:12px;border:0;background:" + ACC + ";color:" + ON + ";font:600 13px/1.25 " + BF + ";letter-spacing:.14em;padding:0 14px;text-transform:uppercase;cursor:pointer;border-radius:0;display:flex;align-items:center;justify-content:center;text-decoration:none}",
      ".btn:hover{filter:brightness(.94)}",
      ".btn[disabled]{opacity:.7;cursor:wait}",
      ".no{margin-top:16px;border:0;background:none;color:" + TXT + ";font:15px/1.4 " + BF + ";text-decoration:underline;cursor:pointer;padding:6px}",
      ".err{min-height:18px;margin:8px 0 0;font-size:13px;color:#b42318}",
      ".legal{margin:18px 0 0;font-size:12.5px;line-height:1.5;opacity:.72;max-width:400px}",
      ".hp{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}",
      ".code{display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;max-width:400px;margin:4px 0 16px;padding:14px 16px;border:2px dashed " + ACC + ";background:#fff}",
      ".code b{font:700 19px/1.25 'Courier New',monospace;letter-spacing:.04em;color:#1f1f1f;overflow-wrap:anywhere;text-align:left;min-width:0}",
      ".cp{flex:none;border:1px solid " + ACC + ";background:transparent;color:" + ACC + ";font:600 12px/1 " + BF + ";letter-spacing:.12em;text-transform:uppercase;padding:9px 12px;cursor:pointer}",
      ".page{max-width:560px;margin:0 auto;padding:40px 24px;text-align:center;font-family:" + BF + ";color:" + TXT + "}",
      ".page .t{font-size:34px}",
      ".page .btn{max-width:320px;margin:8px auto 0}",
      ".page .ok{font-size:15px;margin-top:14px}",
      "@media (max-width:749px){.dlg{flex-direction:column!important;max-width:440px}.img{display:none}.body{padding:34px 22px 24px}.t{font-size:31px}.p{font-size:16px}.btn{letter-spacing:.12em;font-size:13px;padding:0 12px;line-height:1.25}.code{flex-direction:column;align-items:stretch;gap:12px;padding:16px}.code b{text-align:center;font-size:20px}.cp{width:100%;padding:11px 12px}}",
      "@media (prefers-reduced-motion:reduce){.ov,.dlg{transition:none}}"
    ].join("\n");
  }

  // ── telemetry: anonymous counts only (views / closes / declines) ──
  function beacon(t) {
    if (PREVIEW || !C.endpoint) return;
    var body = JSON.stringify({ t: t, test: TEST });
    try {
      if (navigator.sendBeacon) { navigator.sendBeacon(C.endpoint + "/event", body); return; }
    } catch (e) {}
    try { fetch(C.endpoint + "/event", { method: "POST", body: body, keepalive: true, mode: "cors" }); } catch (e) {}
  }

  // ── the modal ──
  var host, root, ov, lastFocus, prevOverflow, shownAt = 0;

  function mount() {
    host = h("div", { id: "rf-welcome-root" });
    root = host.attachShadow ? host.attachShadow({ mode: "open" }) : host;
    root.appendChild(h("style", { text: css() }));
    document.body.appendChild(host);
  }

  function open(content) {
    if (!host) mount();
    lastFocus = document.activeElement;
    var image = safeUrl(B.image_url);
    var side = B.image_side || "left";
    // Phones never show the photo: on a narrow screen it only pushes the form
    // below the fold. The pop-up there is text and the form, on both screens.
    var onDesktop = !!(image && side !== "none");
    var dlg = h("div", { class: "dlg" + (side === "right" ? " flip" : ""), role: "dialog", "aria-modal": "true",
                         "aria-labelledby": "rfw-title" }, [
      onDesktop ? h("div", { class: "img", style: "background-image:url(\"" + image.replace(/"/g, "%22") + "\")",
                             "aria-hidden": "true" }) : null,
      h("div", { class: "body" }, [content]),
      h("button", { class: "x", type: "button", "aria-label": "Close", text: "×", onclick: function () { close("close"); } })
    ]);
    ov = h("div", { class: "ov", onclick: function (e) { if (e.target === ov) close("close"); } }, [dlg]);
    root.appendChild(ov);
    if (!PREVIEW) {
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = "hidden";
    }
    requestAnimationFrame(function () { ov.classList.add("open"); });
    document.addEventListener("keydown", onKey, true);
    var first = root.querySelector("input.fld") || root.querySelector(".btn") || root.querySelector(".x");
    if (first && !PREVIEW) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 60);
    shownAt = Date.now();
  }

  function swap(content) {
    var b = root.querySelector(".body");
    if (!b) return open(content);
    // The code screen keeps the sign-up screen's size: a pop-up that shrinks the
    // moment you subscribe looks broken, and the photo would re-crop.
    var d = root.querySelector(".dlg");
    if (d && !(window.matchMedia && window.matchMedia("(max-width: 749px)").matches)) d.style.minHeight = d.offsetHeight + "px";
    b.textContent = "";
    b.appendChild(content);
  }

  function close(why) {
    if (!ov) return;
    document.removeEventListener("keydown", onKey, true);
    var gone = ov;
    ov = null;
    gone.classList.remove("open");
    setTimeout(function () { if (gone.parentNode) gone.parentNode.removeChild(gone); }, 260);
    if (!PREVIEW) {
      document.documentElement.style.overflow = prevOverflow || "";
      var st = loadState();
      if (why === "decline") { st.status = "never"; beacon("decline"); }
      else if (why === "close" && st.status !== "subscribed") { st.status = "closed"; st.closedAt = Date.now(); st.closedVid = visitId(); beacon("close"); }
      saveState(st);
      try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function onKey(e) {
    if (!ov) return;
    if (e.key === "Escape") { e.preventDefault(); close("close"); return; }
    if (e.key === "Tab") {                                   // keep focus inside the dialog
      var f = Array.prototype.slice.call(root.querySelectorAll("button, input:not(.hp), a[href]"));
      if (!f.length) return;
      var a = root.activeElement || document.activeElement, i = f.indexOf(a);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    }
  }

  function logo() {
    var u = safeUrl(B.logo_url);
    return B.show_logo && u ? h("img", { class: "logo", src: u, alt: C.storeName || "" }) : null;
  }

  // ── screen 1: sign up ──
  function signupView() {
    var P = C.popup1 || {};
    var input = h("input", { class: "fld", type: "email", name: "email", required: true, autocomplete: "email",
                             inputmode: "email", placeholder: P.placeholder || "", "aria-label": P.placeholder || "Email" });
    var hp = h("input", { class: "hp", type: "text", name: "company", tabindex: "-1", autocomplete: "off", "aria-hidden": "true" });
    var err = h("p", { class: "err", role: "alert" });
    var btn = h("button", { class: "btn", type: "submit", text: P.button || "" });
    var form = h("form", { novalidate: true, onsubmit: function (e) {
      e.preventDefault();
      if (PREVIEW) return;
      var v = (input.value || "").trim();
      if (!/^[^\s@]{1,64}@[^\s@]+\.[A-Za-z]{2,24}$/.test(v)) { err.textContent = (C.errors || {}).email || ""; input.focus(); return; }
      err.textContent = "";
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = "…";
      fetch(C.endpoint + "/subscribe", {
        method: "POST", mode: "cors", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: v, hp: hp.value, ms: Date.now() - shownAt, page: location.pathname, test: TEST })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok && j.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            btn.disabled = false; btn.textContent = label;
            err.textContent = res.j && res.j.error === "email" ? (C.errors || {}).email : (C.errors || {}).generic;
            return;
          }
          var st = loadState(); st.status = "subscribed"; saveState(st);
          swap(codeView(res.j.code));
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; err.textContent = (C.errors || {}).generic || ""; });
    } }, [input, hp, btn, err]);
    return h("div", null, [
      logo(),
      P.eyebrow ? h("p", { class: "eb", text: P.eyebrow }) : null,
      h("h2", { class: "t", id: "rfw-title", text: P.title || "" }),
      P.body ? h("p", { class: "p", text: P.body }) : null,
      form,
      P.decline ? h("button", { class: "no", type: "button", text: P.decline, onclick: function () { close("decline"); } }) : null,
      P.legal ? h("p", { class: "legal", text: P.legal }) : null
    ]);
  }

  // ── screen 2: the code ──
  function codeView(code) {
    var P = C.popup2 || {};
    var title = String(P.title || "");
    var box = null;
    if (code) {
      var cp = h("button", { class: "cp", type: "button", text: P.copy || "Copy", onclick: function () {
        var done = function () { cp.textContent = P.copied || "✓"; };
        try { navigator.clipboard.writeText(code).then(done, done); } catch (e) { done(); }
      } });
      box = h("div", { class: "code" }, [h("b", { text: code }), cp]);
    }
    var href = safeUrl(P.button_url, true) || "/";
    return h("div", null, [
      logo(),
      P.eyebrow ? h("p", { class: "eb", text: P.eyebrow }) : null,
      h("h2", { class: "t", id: "rfw-title", text: title }),
      box,
      P.body ? h("p", { class: "p", text: P.body }) : null,
      P.button ? h("a", { class: "btn", href: href, text: P.button, onclick: function () { close("done"); } }) : null
    ]);
  }

  // ── the unsubscribe page (/pages/<handle>?t=…) ──
  function unsubscribePage(el, forced) {
    var U = C.unsubscribe || {};
    var shadow = el.attachShadow ? el.attachShadow({ mode: "open" }) : el;
    shadow.appendChild(h("style", { text: css() }));
    var page = h("div", { class: "page" });
    shadow.appendChild(page);
    function show(kids) { page.textContent = ""; kids.forEach(function (k) { if (k) page.appendChild(k); }); }
    function invalid() { show([h("h1", { class: "t", text: U.invalid || "" })]); }
    function done() {
      var msg = h("p", { class: "p ok", role: "status" });
      var again = h("button", { class: "no", type: "button", text: U.resubscribe || "", onclick: function () {
        if (forced) return;
        post({ t: token, action: "resubscribe" }, function () { msg.textContent = U.resubscribed || ""; again.remove(); });
      } });
      show([h("h1", { class: "t", text: U.done_title || "" }), h("p", { class: "p", text: U.done_body || "" }), again, msg]);
    }
    function ask(masked) {
      var err = h("p", { class: "err", role: "alert" });
      var btn = h("button", { class: "btn", type: "button", text: U.button || "", onclick: function () {
        if (forced) return;
        btn.disabled = true;
        post({ t: token }, done, function () { btn.disabled = false; err.textContent = (C.errors || {}).generic || ""; });
      } });
      show([h("h1", { class: "t", text: U.title || "" }),
            h("p", { class: "p", text: (U.body || "") + (masked ? " (" + masked + ")" : "") }), btn, err]);
    }
    function post(body, ok, fail) {
      fetch(C.endpoint + "/unsubscribe", { method: "POST", mode: "cors", headers: { "Content-Type": "application/json" },
                                           body: JSON.stringify(body) })
        .then(function (r) { if (r.ok) ok(); else if (fail) fail(); else invalid(); })
        .catch(function () { if (fail) fail(); });
    }
    if (forced === "unsubscribe") return ask("an•••@example.com");
    if (forced === "unsubscribed") return done();
    var token = params.get("t");
    if (!token) return invalid();
    fetch(C.endpoint + "/unsubscribe?t=" + encodeURIComponent(token), { mode: "cors" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (!j || !j.ok) invalid(); else if (j.status === "unsubscribed") done(); else ask(j.email); })
      .catch(invalid);
  }

  // ── when to show ──
  function eligibleAt() {
    if (C.mode === "off" || (C.mode === "test" && !TEST)) return null;
    var st = loadState();
    if (st.status === "never" || st.status === "subscribed") return null;
    if (R.hide_for_subscribed_customers && C.customer && C.customer.acceptsMarketing) return null;
    var path = location.pathname || "/";
    var ex = R.exclude_paths || [];
    for (var i = 0; i < ex.length; i++) if (ex[i] && path.indexOf(ex[i]) === 0) return null;
    if (!R.show_on_mobile && window.matchMedia && window.matchMedia("(max-width: 749px)").matches) return null;
    var vid = visitId();
    var delay = Math.max(0, Number(R.delay_seconds) || 0) * 1000;
    if (st.status !== "closed") return visitStart() + delay;
    var at = [];
    if (R.reshow_next_visit && st.closedVid && st.closedVid !== vid) at.push(visitStart() + delay);
    if (Number(R.reshow_after_minutes) > 0 && st.closedAt) at.push(Number(st.closedAt) + Number(R.reshow_after_minutes) * 60000);
    return at.length ? Math.min.apply(null, at) : null;
  }

  function start() {
    var page = document.querySelector("[data-rf-unsubscribe]");
    if (PREVIEW) {
      var s = C.previewScreen || "popup1";
      if (s === "unsubscribe" || s === "unsubscribed") {
        var el = page || document.body.appendChild(h("div", { "data-rf-unsubscribe": true }));
        return unsubscribePage(el, s);
      }
      // The code screen is previewed the way shoppers reach it: sign-up first, then the swap.
      open(signupView());
      if (s === "popup2") swap(codeView(C.previewCode || ""));
      return;
    }
    if (page) return unsubscribePage(page, null);            // the unsubscribe page never shows the pop-up
    var at = eligibleAt();
    if (at == null) return;
    setTimeout(function () {
      if (eligibleAt() == null || ov) return;               // state changed in another tab meanwhile
      open(signupView());
      beacon("view");
    }, Math.max(0, at - Date.now()));
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
